import React, { useState } from "react";
import { Search, Close } from "@carbon/icons-react";
import "./InputSearch.css";

export interface InputSearchProps {
  /**
   * Placeholder text for the search input
   */
  placeholder?: string;

  /**
   * Current value of the search input
   */
  value?: string;

  /**
   * Callback function when the value changes
   */
  onChange?: (value: string) => void;

  /**
   * Whether the component is disabled
   */
  disabled?: boolean;

  /**
   * Whether there is an error
   */
  error?: boolean;

  /**
   * Error message to display
   */
  errorMessage?: string;

  /**
   * Additional CSS class
   */
  className?: string;
}

/**
 * Component for search input with icon and clear button
 */
export const InputSearch: React.FC<InputSearchProps> = ({
  placeholder = "Buscar",
  value = "",
  onChange,
  disabled = false,
  error = false,
  errorMessage,
  className = "",
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.value);
  };

  const handleClear = () => {
    onChange?.("");
  };

  const containerClasses = [
    "qida-input-search",
    error ? "qida-input-search--error" : "",
    disabled ? "qida-input-search--disabled" : "",
    isFocused ? "qida-input-search--focused" : "",
    value ? "qida-input-search--filled" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      <div className="qida-input-search__input-container">
        <div className="qida-input-search__icon-text">
          <div className="qida-input-search__icon">
            <Search size={20} />
          </div>
          <input
            type="text"
            className="qida-input-search__input"
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            disabled={disabled}
          />
          {value && (
            <button
              className="qida-input-search__clear-button"
              onClick={handleClear}
              disabled={disabled}
              type="button"
            >
              <Close size={12} />
            </button>
          )}
        </div>
      </div>

      {error && errorMessage && (
        <div className="qida-input-search__error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default InputSearch;
